import { Formik } from "formik";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { Grid, Box, Link, Typography } from "@mui/material"; // Added Link
import { useNavigate } from "react-router-dom";

import VisitorFormDisplay from "./VisitorFormDisplay";
import { useAlert, useAxios } from "../../hooks";
import {
  visitorSignUpDetailsObject,
  visitorSignUpValidationSchema,
} from "./visitorSignUpDetailsObject";
import icon from "../MobileVerification/assests/icon.svg"; // Imported icon
import { SubheaderSection } from "../../components"; // Imported SubheaderSection

export default function VisitorSignUp() {
  const axios = useAxios({
    disableAuthToken: true,
  });
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Fragment>
      <Grid container flexDirection={"column"}>
        <Grid item container className="eventImageBox">
          <div style={{ width: "100%", position: "fixed", overflow: "hidden" }}>
            <img
              src={icon}
              style={{ width: "100%", height: "40vh" }}
              alt="icon"
            />
          </div>
        </Grid>

        <Grid item padding={"0px"}>
          <Grid item container justifyContent={"center"}>
            <Grid
              item
              md={12}
              sl={6}
              zIndex={99999}
              marginTop={"22vh"}
              sx={{
                alignContent: "center",
                width: "100%",
                padding: "0px 25px",
                // height: "64vh", // Removed fixed height to allow form to grow
                minHeight: "64vh",
                paddingBottom: "20px",

                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Grid
                item
                container
                sx={{
                  justifyContent: "center",
                }}
              >
                <SubheaderSection
                  textAlign="start"
                  title="Visitor Sign Up"
                  content="Enter your details to create an account."
                />

                <Formik
                  initialValues={visitorSignUpDetailsObject}
                  validationSchema={visitorSignUpValidationSchema}
                  validateOnMount
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      const res = await axios({
                        url: "/event/visitor/sign-up",
                        method: "POST",
                        data: values,
                        disableRedirect: true,
                      });

                      if (res.status) {
                        dispatch(
                          alert({
                            message: "Sign up successful! Please log in.",
                            type: "success",
                          })
                        );
                        navigate("/login");
                      }
                    } catch (error) {
                      console.error("Sign up error:", error);
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {(formikProps) => (
                    <form
                      onSubmit={formikProps.handleSubmit}
                      style={{ width: "100%" }}
                    >
                      <VisitorFormDisplay formikProps={formikProps} />
                    </form>
                  )}
                </Formik>

                <Box mt={3} textAlign="center" width="100%">
                  <Typography variant="body2" sx={{ color: "#757575" }}>
                    Already have an account?{" "}
                    <Link
                      component="button"
                      type="button"
                      onClick={() => navigate("/login")} // Changed to sign-in
                      sx={{
                        fontWeight: 600,
                        color: "#667eea",
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      Sign In
                    </Link>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}
